import { DateRangePickerWrapper } from 'components/Date/DateRangePicker';
import { Loading } from 'components/loading/Loading';
import { tableStyles } from 'css/tableStyles';
import React, { useEffect, useMemo, useState } from 'react';
import DataTable from 'components/DataTable';
import { fetchHistoryForInventoryItemStatus } from 'services/api/inventoryItems';
import { DATE_FORMATS, formatDate, getPageLimit, showError, updatePageLimit } from 'utils';
import styles from './index.module.scss';
import moment from 'moment';
import ActionButton from 'components/ActionButton';
import CustomLink from 'components/TableLink';

let filters: {
  [p: string]: any;
  page: number;
  startDate: string | null;
  endDate: string | null;
} = {
  page: 0,
  limit: getPageLimit(),
  startDate: moment().subtract(1, 'week').toString(),
  endDate: moment().toString(),
};

const ActiveStatusHistory = props => {
  const [historyLogs, setHistoryLogs] = useState<Record<string, any>>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<string | null>(filters.startDate);
  const [endDate, setEndDate] = useState<string | null>(filters.endDate);
  const { itemId } = props;

  const columns = useMemo(() => [
    {
      name: 'User Id',
      cell: row => {
        return <CustomLink linkTo={`/users/${row?.user?.id}`} text={row?.user?.id} />;
      },
    },
    {
      name: 'New Status',
      selector: 'newStatus',
      cell: row => {
        return <div>{row?.newStatus?.toString()}</div>;
      },
    },
    {
      name: 'Previous Status',
      selector: 'previousStatus',
      cell: row => {
        return <div>{row?.previousStatus?.toString()}</div>;
      },
    },
    {
      name: 'Date',
      selector: 'createdAt',
      format: (row) => formatDate(row.createdAt, DATE_FORMATS.MM_DD_YYYY_hh_mm_A),
      sortable: true,
    },
  ], []);

  const fetchHistoryForInventoryItemStatusFn = async () => {
    setLoading(true);
    try {
      const response = await fetchHistoryForInventoryItemStatus({
        ...filters,
        id: itemId,
        startDate: formatDate(filters.startDate, DATE_FORMATS.YYYY_MM_DD),
        endDate: formatDate(filters.endDate, DATE_FORMATS.YYYY_MM_DD),
      });
      console.log(response, 'responseresponse');

      setHistoryLogs(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistoryForInventoryItemStatusFn();
  }, []);

  const onChangePage = (page: number) => {
    filters.page = page - 1;
    fetchHistoryForInventoryItemStatusFn();
  };

  const onChangeRowsPerPage = (rowsPerPage: number, currentPage: number) => {
    filters.limit = rowsPerPage;
    updatePageLimit(rowsPerPage);
    onChangePage(currentPage);
  };

  const onDateSelectionChange = ({ startDate, endDate }: { startDate: Date; endDate: Date }) => {
    filters = {
      ...filters,
      startDate: moment(startDate).toISOString(),
      endDate: moment(endDate).toISOString(),
    };
    setStartDate(moment(startDate).toISOString());
    setEndDate(moment(endDate).toISOString());
  };

  const Filter = () => (
    <div className={'d-flex flex-column flex-md-row align-items-center align-items-md-end mb-3 mt-3 mt-md-0'}>
      <DateRangePickerWrapper
        startDate={startDate}
        endDate={endDate}
        onDatesChange={onDateSelectionChange}
      />
      <ActionButton
        text={'Submit'}
        active={!loading}
        isLoading={loading}
        onClick={fetchHistoryForInventoryItemStatusFn}
        customClass={'ml-3 mt-3 mt-md-0'}
      />
    </div>
  );

  const SectionHeader = () => (
    <div className={`d-flex px-0 px-md-4 justify-content-between align-items-center flex-column flex-md-row`}>
      <div style={{ fontSize: `20px`, lineHeight: `26px`, color: "#161616" }} className={styles['section-heading mb-3']}>Active Status History</div>
      <div className={'ml-0 ml-lg-auto'}>
        <Filter />
      </div>
    </div>
  );

  const getDataTable = () => {
    if (loading) return <Loading type={'mini'} />;
    return (
      <DataTable
        keyField="objectid"
        columns={columns}
        noHeader={true}
        data={historyLogs.items}
        highlightOnHover={true}
        defaultSortField="createdAt"
        customStyles={tableStyles}
        pagination={true}
        paginationServer={true}
        paginationPerPage={getPageLimit()}
        paginationDefaultPage={(filters.page || 0) + 1}
        paginationTotalRows={historyLogs.total}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
      />
    );
  };

  return (
    <div className={styles['item-history-log-container']}>
      <SectionHeader />
      {getDataTable()}
    </div>
  );
};

export default ActiveStatusHistory;
